import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";
import "highlight.js/styles/atom-one-dark.css";

export default function Markdown({ children, className = "" }) {
  return (
    <div className={`prose prose-invert prose-sm max-w-none ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeHighlight]}
        components={{
          a: ({ node, ...props }) => <a {...props} target="_blank" rel="noreferrer" className="text-primary underline underline-offset-4" />,
          img: ({ node, ...props }) => <img {...props} className="rounded-lg border border-border/60 my-3" />,
          code: ({ inline, className, children, ...props }) =>
            inline
              ? <code className="px-1 py-0.5 rounded bg-secondary/60 font-mono text-[0.85em]" {...props}>{children}</code>
              : <code className={`${className || ""} font-mono text-[13px]`} {...props}>{children}</code>,
          pre: ({ children }) => <pre className="rounded-lg overflow-x-auto border border-border/60 !bg-[#0d1117] p-3">{children}</pre>,
          h1: (p) => <h1 className="font-display font-black tracking-tighter text-2xl mt-4 mb-2" {...p} />,
          h2: (p) => <h2 className="font-display font-bold text-xl mt-4 mb-2" {...p} />,
          h3: (p) => <h3 className="font-display font-bold text-lg mt-3 mb-2" {...p} />,
          ul: (p) => <ul className="list-disc pl-5 space-y-1" {...p} />,
          ol: (p) => <ol className="list-decimal pl-5 space-y-1" {...p} />,
          blockquote: (p) => <blockquote className="border-l-2 border-primary/40 pl-3 italic text-muted-foreground" {...p} />,
          table: (p) => <div className="overflow-x-auto"><table className="border border-border/60 rounded" {...p} /></div>,
          th: (p) => <th className="border border-border/60 px-2 py-1 bg-secondary/50 text-left" {...p} />,
          td: (p) => <td className="border border-border/60 px-2 py-1" {...p} />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
